import { GET_LATEST_LOCATION_LIST } from "../../../modules/constants";

export function getLatestLocationList(payload) {
  return {
    type: GET_LATEST_LOCATION_LIST,
    payload,
  };
}
